module.exports = __webpack_public_path__ + "static/img-1-5cdb9621e955e1de69c5ee052c054c79.jpeg";